import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-666f8a7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-value"]

import { computed } from 'vue';
import { Builds_BuildResult } from '@/graphql/codegen/generated/graphql';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dateUtils } from '@/services/dateUtils';
import { STATUS_ICON_MAP, workloadsResultToDisplayMapping } from '../workloads.const';
import { useWorkloadsTableUtils } from '../workloads.utils';
import WorkloadViewHeaderInfoProps from './workload-view-header-info-props.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-header-info',
  props: {
    status: null,
    startTime: null,
    duration: null,
    initiator: null,
    loggedOnUsers: null,
    project: null,
    buildType: null
  },
  setup(__props: any) {

const props = __props as {
  status: Builds_BuildResult;
  startTime: number;
  duration: number;
  initiator: string;
  loggedOnUsers: string;
  project: string;
  buildType: string;
}



const { secondsToHoursMinutesAndSeconds } = useWorkloadsTableUtils();

const borderClass = computed(() => `border-${props.status?.toLowerCase()}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, {
    class: _normalizeClass(["workload-view-header-info flex flex-nowrap flex-row h-[64px] items-center border border-Old/System/app_border border-solid", _unref(borderClass)])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "status gordita-medium-500-14 flex flex-row place-items-center flex-nowrap gap-3 px-[16px] w-[19%]",
        "data-testid": "build-status",
        "data-value": __props.status
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["icon uis text-[32px]", _unref(STATUS_ICON_MAP)[__props.status]])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_unref(workloadsResultToDisplayMapping)[__props.status]), 1)
      ], 8, _hoisted_1),
      _createVNode(WorkloadViewHeaderInfoProps, {
        class: "border-r-Border/border_natural border-l w-[27%]",
        entries: [
        {
          title: _ctx.$t('workloads.details.header.startTime'),
          value: _unref(dateUtils).getRunningSinceDateFormat(__props.startTime),
          noTooltip: true,
          dataTestId: 'workload-view-header-info-props--start-time',
          dataOriginalValue: `${__props.startTime}`,
        },
        {
          title: _ctx.$t('workloads.details.header.duration'),
          value: _unref(secondsToHoursMinutesAndSeconds)(__props.duration),
          noTooltip: true,
          dataTestId: 'workload-view-header-info-props--duration',
          dataOriginalValue: `${__props.duration}`,
        },
      ],
        icon: "Iconscout/uil uil-clock"
      }, null, 8, ["entries"]),
      _createVNode(WorkloadViewHeaderInfoProps, {
        class: "border-r-Border/border_natural border-l w-[27%]",
        entries: [
        { title: _ctx.$t('workloads.details.header.initiator'), value: __props.initiator, dataTestId: 'workload-view-header-info-props--initiator' },
        { title: _ctx.$t('workloads.details.header.loggedOnUser'), value: __props.loggedOnUsers, dataTestId: 'workload-view-header-info-props--logged-on-users' },
      ],
        icon: "Iconscout/uil uil-desktop"
      }, null, 8, ["entries"]),
      _createVNode(WorkloadViewHeaderInfoProps, {
        class: "border-r-Border/border_natural border-l w-[27%]",
        entries: [
        { title: _ctx.$t('workloads.details.header.project'), value: __props.project, dataTestId: 'workload-view-header-info-props--project' },
        { title: _ctx.$t('workloads.details.header.buildType'), value: __props.buildType, noTooltip: true, dataTestId: 'workload-view-header-info-props--build-type' },
      ],
        icon: "incredicon-build ml-0"
      }, null, 8, ["entries"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})